var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"pd30"},[_c('div',[_c('member-coupon',{ref:"index",attrs:{"member_id":_vm.member_id},on:{"refreash":_vm.refreash}})],1),_c('div',{staticClass:"mt30"},[_c('member-coupon-logs',{ref:"logs",attrs:{"member_id":_vm.member_id}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }